import { NextSeo } from 'next-seo';
import ContactForm from '../components/form/contactForm';
import Socials from '../components/blog/social';
import { withAnimation } from '../utils/hoc';

function ContactPage({ admin, socials }) {
	return (
		<>
			<NextSeo title="Contact" titleTemplate={`%s | ${admin?.name}`} />

			<section
				className="hero is-fullheight is-fullheight-with-navbar"
				style={{ display: 'flex' }}>
				<div className="waves"></div>
				<div className="hero-body">
					<div className="container has-text-centered" style={{ zIndex: 10 }}>
						<div className="columns is-8 is-variable ">
							<div className="column is-one-thirds has-text-left">
								<h1 className="title is-1">CONTACT ME</h1>
								<p className="is-size-4">
									How can technology help you to realize your ambitions?
									<br /> <br /> Get in touch and let's find out.
								</p>
								<br />
								<Socials list={socials} />
							</div>
							<div className="column is-two-third has-text-left">
								<ContactForm />
							</div>
						</div>
					</div>
				</div>
			</section>
		</>
	);
}

export default withAnimation(ContactPage);
